<template>
  <div class="bg-peacock-700">
    <div class="container relative z-10 py-10 lg:py-20">
      <div class="lg:w-3/4">
        <h2 class="max-w-xl text-xl font-semibold text-white xl:text-2xl">
          <slot name="title">
            {{ $t('pages.index.title_seo') }}
          </slot>
        </h2>
      </div>
      <div class="mt-8 lg:w-3/4">
        <HoSearchBar />
      </div>
      <div class="hidden lg:absolute lg:right-10 lg:top-9 lg:block xl:right-1/3">
        <img
          src="~/assets/img/commons/stamp.svg"
          alt="-"
          loading="lazy"
        >
      </div>
    </div>
  </div>
</template>
